import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Paper,
  PaperProps,
  Stack,
  Typography,
} from '@mui/material';
import { useRef } from 'react';
import Draggable from 'react-draggable';
import { Modals, useModalMethods } from 'src/store/modals';

interface GenericDialogProps extends Omit<DialogProps, 'open'> {
  modal: Modals;
  open?: boolean;
  draggable?: boolean;
  title: string;
  actionButtons?: React.ReactNode;
  children: React.ReactNode;
}

const PaperComponent = (props: PaperProps) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

export const GenericDialog = ({
  modal,
  open = true,
  draggable = false,
  title,
  actionButtons,
  children,
  ...rest
}: GenericDialogProps) => {
  const { closeModal } = useModalMethods(modal);
  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth
      {...(draggable ? { PaperComponent } : {})}
      {...rest}
    >
      <DialogTitle
        {...(draggable ? { style: { cursor: 'move' }, id: 'draggable-dialog-title' } : {})}
        sx={{
          borderBottom: '1px solid',
          borderColor: (theme) => theme.palette.custom.OV.sys.outlineVariant,
        }}
      >
        <Stack direction="row" spacing={2}>
          <Typography variant="overline">{title}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>{actionButtons}</DialogActions>
    </Dialog>
  );
};
